.wrap {
  position: relative;
  width: clamp(9rem, 34vw, 14rem);
  height: clamp(9rem, 34vw, 14rem);
  display: grid;
  place-items: center;
}

.ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1px solid var(--gold-soft);
}

.ink {
  position: absolute;
  inset: 14%;
  border-radius: 50%;
  background: radial-gradient(circle at 38% 32%, rgba(184, 150, 104, 0.22), transparent 62%),
    radial-gradient(circle at 60% 70%, rgba(179, 71, 51, 0.16), transparent 60%),
    radial-gradient(circle at 50% 50%, var(--ink-3), var(--ink) 80%);
  box-shadow:
    inset 0 0 40px rgba(0, 0, 0, 0.6),
    0 0 60px rgba(184, 150, 104, 0.06);
}

.core {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--cinnabar);
  box-shadow: 0 0 18px rgba(179, 71, 51, 0.7);
}

/* CSS-driven breathing so it animates even where Framer is reduced */
@media (prefers-reduced-motion: no-preference) {
  .ring {
    animation: breathe 7s var(--ease-soft) infinite;
  }
  .ink {
    animation: breathe 7s var(--ease-soft) infinite;
  }
  .core {
    animation: pulse 7s var(--ease-soft) infinite;
  }
}

@keyframes breathe {
  0%,
  100% {
    transform: scale(0.92);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.04);
    opacity: 1;
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.5;
    transform: scale(0.85);
  }
  50% {
    opacity: 1;
    transform: scale(1.15);
  }
}
